import {CLOSE_NOTIFICATION} from "./NotificationsActions";
import {SAVE_SIGNATURE_SUCCESS} from "../../containers/signature/SignatureActions";
import {DESTROY_ACCOUNT, GET_DESTROY_STATUS, GET_DEVICES} from "../../redux/types";

const INITIAL_STATE = {text: ''};

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case GET_DEVICES:
            if(action.error){
                return {text: `Devices was not found. ${action.payload.message}`};
            }
            break;
        case SAVE_SIGNATURE_SUCCESS:
            return {text: 'Signature saved'};
        // case DESTROY_ACCOUNT:
        //     if(action.error){
        //         return {text: `Account was not deleted. ${action.payload.message}`};
        //     }
        //     return {text: 'Account deleted'};
        case GET_DESTROY_STATUS:
            if(action.error){
                return {text: `Status was not found. ${action.payload.message}`};
            }
            break;
        case CLOSE_NOTIFICATION:
            return INITIAL_STATE;
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/components/notifications/NotificationsReducer.js